<template>
  <div>
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div>{{ currItem.question_description_obj[computedLang] }}</div>
      </div>
      <div class="panel-content">
        <!-- 小题目的 分数 -->
        <div class="panel-article">
          <p v-for="(text, textIndex) in currItem.screen_text" :key="'text' + textIndex">
            <span v-html="text.content"></span>
          </p>
        </div>
        <template v-for="(item, key) in currItem.questions">
          <div :key="item.index + key" class="question-item">
            <p class="question-stem">
              <span class="question-index">{{ item.index }}.</span>
              <span v-html="item.screen_text[0].content"></span>
            </p>

            <div class="answer_result">
              <div class="answer_result-title">{{ $t('mark_answer') }}:</div>
              <div v-if="item.useAnswer">
                <p class="title">{{ item.useAnswer }}</p>
              </div>
              <strong v-else>{{ $t('hsk_homework_no_answer') }}</strong>
            </div>
            <div class="reference_answer">
              <div>{{ $t('hsk_reference_answer') }}</div>
              <p>{{ item.evaluate.standard_answer[0] }}</p>
            </div>

            <div class="score-option">
              <div>{{ $t('evaluate_common_total_score') }}：</div>
              <div>
                <el-select
                  v-model="item.markScore"
                  placeholder=""
                  size="mini"
                  :disabled="$route.query.optionStatus != 1"
                >
                  <el-option
                    v-for="scoreIndex in item.score + 1"
                    :key="scoreIndex"
                    :label="scoreIndex - 1"
                    :value="scoreIndex - 1"
                  >
                  </el-option>
                </el-select>
                / {{ item.score }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </Panel>
  </div>
</template>

<script>
export default {
  name: 'CommonListenLrResult',
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {}
  },
  watch: {
    currItem: {
      handler(val) {
        if (val && val.index) {
          if (val.useAnswer) {
            // this.inputTitle = val.useAnswer.split('&&')[0]
            // this.inputText = val.useAnswer.split('&&')[1]
            // console.log(val.useAnswer)
            // this.inputTextResult = val.useAnswer.split('&&')[1].split('\n') || []
            // console.log(this.inputTextResult)
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    computedLang() {
      return localStorage.getItem('language') || 'en'
    },

    // analysisText() {
    //   return this.currItem.evaluate.standard_answer[0].split('\n')
    // },
  },
  methods: {
    clickPlayTopVoice(status, isTryAgain) {
      if (this.isExamMode && status) return
      this.currItem.questions.forEach((question) => {
        question.playStatus = 'play'
      })
      this.topPlayStatus = 'pause'
      let audioPath = this.baseUrl + this.currItem.listen.audio_file
      console.log('题干播放链接===', audioPath)
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.topPlayStatus = 'play'
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.clickPlayTopVoice(false, true)
              layer.close(index)
            },
            btn2: (index) => {
              _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
              layer.close(index)
            },
          })
        } else {
          _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
      }
      localStorage.setItem('bigIndex', this.currItem.bigIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.question-item {
  border-bottom: 1px dashed #eee;
  padding-bottom: 20px;
  position: relative;
}
.score-option {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  .el-select--mini {
    width: 60px;
    ::v-deep .el-input__inner {
      height: 24px !important;
      padding: 0 0 0 10px;
    }
    ::v-deep .el-input__icon {
      line-height: 25px;
    }
  }
}
.question-stem {
  margin-bottom: 20px;
  margin-top: 20px;

  .question-index {
    color: #b5b5be;
    margin-right: 8px;
  }
}

.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  .answer_result {
    &-title {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      text-indent: 2em;
      line-height: 25px;
    }
    strong {
      font-weight: 600;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
    }
  }
}
</style>
